<template>
  <div class="hero">
		<div class="hero__inner">
			<VimeoPlayer v-if="content?.singleVideo?.videoId" class="hero__player video video--vimeo"
									 ref="heroPlayer"
									 :video-id="content.singleVideo.videoId"
									 :controls="false"
									 :loop="true"
									 autoplay="autoplay"
									 muted="muted"
									 @ready="onReady"/>
		</div>
		<button v-if="content?.singleVideo?.videoId" @click="toggleMute"
							class="hero__demute"
						aria-label="demute"
						ref="heroButton">
			<svg version="1.1"
					 id="button-mute"
					 xmlns="http://www.w3.org/2000/svg"
					 x="0"
					 y="0"
					 viewBox="0 0 180.5 180.5"
					 style="enable-background:new 0 0 180.5 180.5"
					 xml:space="preserve">
				<g class="button__speaker">
					<path d="M24.4 59h2.8c1.3.1 2.5-.3 3.3-1.4 1.6-1.9 3.5-3.6 5.2-5.4 4.8-4.8 9.7-9.6 14.4-14.5 2.4-2.4 4.6-4.9 7.1-7.2 2.6-2.3 5.5-3.8 9.2-3.8 2.8 0 5.5.5 7.9 2 3.3 2 5.5 5 6.5 8.8.7 2.6.8 5.2.8 7.8-.1 24.5-.1 49 0 73.5 0 4 .1 8 0 12-.1 1.8.2 3.5.1 5.2-.2 4-1.2 7.8-4.1 10.7-2.2 2.3-5 3.7-8 4.4-4.4 1-8.3-.3-11.8-3-2.7-2.1-5.1-4.5-7.4-6.9-2.3-2.5-4.8-4.7-7.3-6.9-2.3-2.1-4.6-4.3-6.8-6.5-1.6-1.5-3.1-3-4.9-4.4-.7-.5-1.1-1.4-1.9-1.9-.6-.4-1.3-.6-2-.6-2 0-3.9.1-5.9 0-4.6-.1-8.7-1.6-12.2-4.5-3.3-2.7-5.4-6.3-6.1-10.6-.4-2.2-.5-4.4-.5-6.6 0-7.1-.1-14.3 0-21.4.1-4.3 1.1-8.5 3.9-12 2.4-2.9 5.4-4.9 9-5.9 2.9-.9 5.8-1 8.7-.9zM62 89.5V58.4c0-1-.2-1.9-.4-2.8-.2-1-.5-1-1.3-.4-1.6 1.2-2.9 2.7-4.3 4.1-5 5-10.1 10-15.1 15.1-2.9 2.9-6.4 4.3-10.5 4.3h-6.2c-.7 0-1.1.3-1.3.9-.4 1.2-.5 2.4-.5 3.6 0 4-.1 8-.1 12 0 1.4-.1 2.9.2 4.3.1.5.2 1 .8 1.1.8.1 1.7.3 2.5.3 1.8.1 3.6 0 5.4.1 3.5.2 6.5 1.6 9.1 3.9 2.4 2.2 4.8 4.6 7.3 6.8 2.7 2.4 5.2 4.9 7.8 7.3 1.5 1.4 3.1 2.8 4.6 4.3.6.6 1.1.5 1.4-.3.3-.7.4-1.5.4-2.3.2-10.4.2-20.8.2-31.2z"/>
				</g>
				<g class="button__sound">
					<path d="M149.1 19.5c2.4 0 4.4 1 6 2.8 2.4 2.8 4.2 6 6.2 9.1 2 3.2 3.7 6.5 5.3 9.9 2.3 4.8 4.3 9.8 5.9 14.9 1.3 4 2.4 8 3.2 12 .4 2.2.8 4.3 1.1 6.5.4 3.2.7 6.3.9 9.5.2 2.7.1 5.3.1 7.9v6.4c0 2.3-.3 4.5-.7 6.8-.2 1.8-.5 3.5-.7 5.3-.4 2.8-.9 5.5-1.6 8.2-1.2 4.8-2.5 9.6-4.2 14.3-1.9 5.2-4.1 10.3-6.8 15.2-1.5 2.6-3.1 5.2-4.9 7.6-1.4 1.9-3.5 3-5.9 3.4-3.3.6-6.5-1.9-7.8-4.3-.5-1-1-2.1-1.2-3.3-.2-1.2.2-2.3.6-3.5.8-2.2 2.2-4.2 3.3-6.3 1.7-3 3.3-6.1 4.7-9.3 2.7-6 4.4-12.4 6-18.7.6-2.3.9-4.6 1.1-6.9.3-2.5.6-5.1.8-7.6.2-3.4.6-6.8.3-10.2-.1-1.3-.2-2.7-.2-4-.1-1.9-.4-3.9-.5-5.8-.1-2.1-.5-4-.9-6.1-.5-3.1-1.3-6-2.1-9-1.2-4.4-2.8-8.6-4.4-12.9-2.2-5.7-5.1-10.9-8.4-15.9-1.3-2-2.5-4-3.3-6.2-.9-2.5 0-4.7 1.5-6.7 1.2-1.6 2.9-2.7 4.8-3.2.7.1 1.2.2 1.8.1z"/>
					<path d="M124.8 144c-4.8 0-7.7-3.5-8.5-7.2-.3-1.5.1-2.9.8-4.3 1.7-3.8 3.7-7.3 5.5-11.1 1.5-3 2.5-6.2 3.4-9.4 1-3.3 1.4-6.7 1.9-10 .4-2.4.5-4.8.6-7.2 0-1.1.2-2.2.2-3.3.1-2.6 0-5.1-.3-7.7-.3-4.1-1.1-8.1-2.1-12.1-1.2-4.9-2.9-9.6-5.2-14.1-1.5-2.9-3.3-5.7-5-8.4-1.2-1.9-2.2-4-2.4-6.2-.1-1.4.4-2.7 1.1-3.9.9-1.5 1.9-2.8 3.5-3.5 3-1.4 5.8-1.2 8.5.7 1.7 1.3 2.8 3 4 4.7 3.1 4.8 5.5 9.9 7.8 15.1 2.2 5 3.7 10.3 5.1 15.6.6 2.4 1.2 4.9 1.5 7.3.2 1.5.3 2.9.4 4.4.2 2.3.4 4.6.4 6.9.1 3.1-.2 6.2-.6 9.2-.5 4.4-1.4 8.7-2.4 13-1.4 6.2-3.8 12-6.2 17.9-1.3 3.1-2.9 6.1-4.7 8.9-1.4 2.1-3.1 3.7-5.7 4.3-.6.4-1.1.3-1.6.4zM113.2 85.4c0 1.6.3 3.3.2 4.9-.2 2.8-.2 5.5-.7 8.3-.6 3.9-1.7 7.7-2.8 11.5-.7 2.5-1.7 5-2.8 7.4-1.2 2.5-2.8 4.6-5.6 5.4-2.3.7-4.6.4-6.6-1-1.8-1.3-3.2-3-3.8-5.2-.4-1.7 0-3.3.6-4.9 1.4-4.1 3-8.1 3.8-12.3.2-1 .4-2 .4-3 0-3.1.4-6.3.3-9.4-.2-4.3-.6-8.6-2-12.8-1-2.8-1.9-5.6-2.9-8.4-1.5-4.2 1.5-8.8 5.3-9.8 3.8-.9 6.6-.2 9 3 1.6 2.1 2.4 4.6 3.5 7 1.2 2.8 2.1 5.8 2.7 8.8.5 2.3.9 4.6 1.1 6.9.1 1.2.3 2.4.3 3.6z"/>
				</g>
			</svg>
		</button>
  </div>
</template>

<script setup>
import {computed, ref, onMounted} from 'vue'
import { useI18n } from '#imports'
import { vueVimeoPlayer as VimeoPlayer } from 'vue-vimeo-player'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
const { locale } = useI18n()
const props = defineProps({
  content: Object
})
let heroTitle
if(props.content.title) {
  heroTitle = computed(() => locale.value === 'en' ? props.content.title.en : props.content.title.jp)
}
const heroPlayer = ref('null')
const heroButton = ref('null')
const muteActive = ref(true)
const onReady = () => {
	heroPlayer.value.playerReady = true
}
const toggleMute = () => {
	if (muteActive.value === true) {
		muteActive.value = !muteActive.value
		heroPlayer.value.unmute()
		gsap.to('.button__sound path', {
			duration: 0.2,
			opacity: 1,
			stagger: 0.1,
			ease: 'back.inOut'
		})
	} else {
		muteActive.value = !muteActive.value
		heroPlayer.value.mute()
		gsap.to('.button__sound path', {
			duration: 0.2,
			opacity: 0,
			stagger: 0.1,
			ease: 'back.inOut'
		})
	}
}

onMounted(() => {
		if (!heroPlayer.value) {
			return
		}
		const play = () => {
			heroPlayer.value.mute()
		heroPlayer.value.play()
	}
	const pause = () => {
		heroPlayer.value.pause()
	}
	play()
	if (process.client) {
		gsap.registerPlugin(ScrollTrigger);
	}
	gsap.to(heroPlayer.value.elementRef,
		{
			scrollTrigger: {
				start: "top center",
				trigger: heroPlayer.value.elementRef,
				onEnterBack: self => {
					play()
				},
				onLeave: self => {
					pause()
				}
			}
		}
	)
})
</script>

<style lang="scss">
@use '@/assets/sass/variables.scss' as v;
.hero {
  background-color: v.$black;
  left: 0;
  width: 100%;
  height: calc(100vh - 6rem);
  overflow: hidden;
  position: relative;
}
.hero__inner {
  width: 100vw;
  height: 56.25vw; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100vh;
  min-width: 177.77vh; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: absolute;
	pointer-events: none;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
	.hero__player {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		iframe {
			position: absolute;
			top: 0;
			left: 0;
			width: 100% !important;
			height: 100% !important;
		}
	}
}

.hero__demute {
	background-color: rgba(0,0,0,0.33);
	border: 0;
	border-radius: 50%;
	bottom: 1rem;
	color: #fff;
	cursor: pointer;
	display: block;
	font-size: 0;
	height: 4rem;
	padding: 1rem;
	position: absolute;
	right: 1rem;
	width: 4rem;
	z-index: 500;
	&:hover {
		background-color: rgba(0,0,0,0.85);
	}
	.button__speaker, .button__sound {
		fill: #fff;
	}
	.button__sound path {
		opacity: 0;
	}
}
</style>
